
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Action {
	id: string;
	name: string;
	description: string | null;
	created_at: string;
	updated_at: string;
	user_id: string;
	action_type: "Task" | "Calendar";
	action_status: string;
	d_begin: string | null;
	d_end: string | null;
	d_duration: number | null;
	sync_status: string | null;
}

export const useActions = (type?: "Task" | "Calendar") => {
	return useQuery({
		queryKey: ["actions", type],
		queryFn: async () => {
			try {
				console.log("Fetching actions with type:", type);
				
				// First, let's check if the table exists
				const { data: tableInfo, error: tableError } = await supabase
					.from('actions')
					.select('id')
					.limit(1);
				
				if (tableError) {
					console.error("Error checking actions table:", tableError);
					throw tableError;
				}
				
				console.log("Table check result:", tableInfo);
				
				// Now fetch the actual data
				let query = supabase.from('actions').select('*');
				
				if (type) {
					console.log("Adding type filter:", type);
					query = query.eq("action_type", type);
				}
				
				const { data, error } = await query.order("created_at", { ascending: false });

				if (error) {
					console.error("Error fetching actions:", error);
					throw error;
				}
				
				console.log(`Fetched ${data?.length || 0} actions${type ? ` of type ${type}` : ''}:`, data);
				
				// Proper casting with an empty array fallback
				return (data || []) as unknown as Action[];
			} catch (error) {
				console.error("Error in useActions:", error);
				throw error;
			}
		},
		refetchOnWindowFocus: true,
		staleTime: 30000, // 30 seconds
	});
};
